module.exports = __webpack_public_path__ + "img/fa-solid-900.27603739.svg";